import axios from 'axios';
import env from 'src/shared/env';

/* eslint-disable import/prefer-default-export */
export function getCount({ year, month, day }) {
  return axios
    .get(`${window.getLinkHomepage()}api/Portal/Count`, {
      params: { year, month, day },
    })
    .then((data) => data.data);
}
